import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  private http = inject(HttpClient);

  constructor() { }

  list(params: any): Observable<any[]> {
    return this.http.get<any[]>(Global.url + 'V1/billing/range-period/'+params.periodStartId + '/' + params.periodEndId, {params});
  }

  generate(periodId: number): Observable<any> {
    return this.http.post<any>(Global.url + 'V1/billing/generate', { periodId });
  }

  getApsMappings(partyIds: number[], forceSync: boolean = false): Observable<any> {
    return this.http.post<any>(Global.url + 'V1/party-sub-account/suggestions', { partyIds, forceSync });
  }

  saveBulkApsMapping(mappings: any[]): Observable<any> {
    return this.http.post<any>(Global.url + 'V1/party-sub-account/bulk', mappings);
  }

  syncApsDatabase(): Observable<any> {
    return this.http.put<any>(Global.url + 'aps-extractor/sync-aps-employee', {});
  }

  importApsEmployee(): Observable<any> {
    return this.http.put<any>(Global.url + 'aps-extractor/import-employee', {});
  }

  markPartiesAccounted(periodUuid: string, entityCode: number): Observable<any> {
    return this.http.put<any>(
      Global.url + 'V1/billing/parties/' + periodUuid + '/mark-accounted',
      { entityCode }
    );
  }
}
